jQuery(() => {
  initOpenClose();
});

// open-close init
function initOpenClose() {
  ResponsiveHelper.addRange({
    '..1023': {
      on() {
        jQuery('.navbar__nav > li:not(.item-bold)').openClose({
          activeClass: 'active',
          opener: '> a',
          slider: '.sub-menu',
          animSpeed: 400,
          effect: 'slide',
        });
      },
      off() {
        jQuery('.navbar__nav > li:not(.item-bold)').openClose('destroy');
      },
    },
  });

  ResponsiveHelper.addRange({
    '..767': {
      on() {
        jQuery('.job-board__table-tbody .job-board__table-row').openClose({
          activeClass: 'active',
          opener: '.opener',
          slider: '.job-board__table-slide',
          animSpeed: 400,
          effect: 'slide',
        });
      },
      off() {
        jQuery('.job-board__table-tbody .job-board__table-row').openClose('destroy');
      },
    },
  });

  ResponsiveHelper.addRange({
    '..1023': {
      on() {
        jQuery('.navbar__nav li.item-bold li.item-bold').openClose({
          activeClass: 'active',
          opener: '> a',
          slider: '.sub-menu',
          animSpeed: 400,
          effect: 'slide',
        });
      },
      off() {
        jQuery('.navbar__nav li.item-bold li.item-bold').openClose('destroy');
      },
    },
  });

  jQuery('.cta').openClose({
    activeClass: 'active',
    opener: '.cta__btn-opener',
    slider: '.cta__drop',
    animSpeed: 400,
    effect: 'slide',
  });
}

/*
 * jQuery Open/Close plugin
 */
(function ($) {
  function OpenClose(options) {
    this.options = $.extend({
      addClassBeforeAnimation: true,
      hideOnClickOutside: false,
      activeClass: 'active',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 400,
      effect: 'fade',
      event: 'click',
    }, options);
    this.init();
  }
  OpenClose.prototype = {
    init() {
      if (this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.makeCallback('onInit', this);
      }
    },
    findElements() {
      this.holder = $(this.options.holder);
      this.opener = this.holder.find(this.options.opener);
      this.slider = this.holder.find(this.options.slider);
    },
    attachEvents() {
      // add handler
      const self = this;
      this.eventHandler = function (e) {
        e.preventDefault();
        if (self.slider.hasClass(slideHiddenClass)) {
          self.showSlide();
        } else {
          self.hideSlide();
        }
      };
      self.slider.attr('aria-hidden', 'true');
      self.opener.attr('aria-expanded', 'false');
      self.opener.on(self.options.event, this.eventHandler);

      // hover mode handler
      if (self.options.event === 'hover') {
        self.opener.on('mouseenter', () => {
          if (!self.holder.hasClass(self.options.activeClass)) {
            self.showSlide();
          }
        });
        self.holder.on('mouseleave', () => {
          self.hideSlide();
        });
      }

      // outside click handler
      self.outsideClickHandler = function (e) {
        if (self.options.hideOnClickOutside) {
          const target = $(e.target);
          if (!target.is(self.holder) && !target.closest(self.holder).length) {
            self.hideSlide();
          }
        }
      };

      // set initial styles
      if (this.holder.hasClass(this.options.activeClass)) {
        $(document).on('click touchstart', self.outsideClickHandler);
      } else {
        this.slider.addClass(slideHiddenClass);
      }
    },
    showSlide() {
      const self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.addClass(self.options.activeClass);
      }
      self.slider.attr('aria-hidden', 'false');
      self.opener.attr('aria-expanded', 'true');
      self.slider.removeClass(slideHiddenClass);
      $(document).on('click touchstart', self.outsideClickHandler);

      self.makeCallback('animStart', true);
      toggleEffects[self.options.effect].show({
        box: self.slider,
        speed: self.options.animSpeed,
        complete() {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.addClass(self.options.activeClass);
          }
          self.makeCallback('animEnd', true);
        },
      });
    },
    hideSlide() {
      const self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.removeClass(self.options.activeClass);
      }
      $(document).off('click touchstart', self.outsideClickHandler);

      self.makeCallback('animStart', false);
      toggleEffects[self.options.effect].hide({
        box: self.slider,
        speed: self.options.animSpeed,
        complete() {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.removeClass(self.options.activeClass);
          }
          self.slider.addClass(slideHiddenClass);
          self.slider.attr('aria-hidden', 'true');
          self.opener.attr('aria-expanded', 'false');
          self.makeCallback('animEnd', false);
        },
      });
    },
    destroy() {
      this.slider.removeClass(slideHiddenClass).css({
        display: '',
      });
      this.opener.off(this.options.event, this.eventHandler);
      this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
      $(document).off('click touchstart', this.outsideClickHandler);
    },
    makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        const args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
  };

  // add stylesheet for slide on DOMReady
  var slideHiddenClass = 'js-slide-hidden';
  (function () {
    const tabStyleSheet = $('<style type="text/css">')[0];
    let tabStyleRule = `.${slideHiddenClass}`;
    tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
    }
    $('head').append(tabStyleSheet);
  }());

  // animation effects
  var toggleEffects = {
    slide: {
      show(o) {
        o.box.stop(true).hide().slideDown(o.speed, o.complete);
      },
      hide(o) {
        o.box.stop(true).slideUp(o.speed, o.complete);
      },
    },
    fade: {
      show(o) {
        o.box.stop(true).hide().fadeIn(o.speed, o.complete);
      },
      hide(o) {
        o.box.stop(true).fadeOut(o.speed, o.complete);
      },
    },
    none: {
      show(o) {
        o.box.hide().show(0, o.complete);
      },
      hide(o) {
        o.box.hide(0, o.complete);
      },
    },
  };

  // jQuery plugin interface
  $.fn.openClose = function (opt) {
    const args = Array.prototype.slice.call(arguments);
    const method = args[0];

    return this.each(function () {
      const $holder = jQuery(this);
      const instance = $holder.data('OpenClose');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data('OpenClose', new OpenClose($.extend({
          holder: this,
        }, opt)));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
}(jQuery));

/*
 * Responsive Layout helper
 */
window.ResponsiveHelper = (function ($) {
  // init variables
  const handlers = [];
  let prevWinWidth;
  const win = $(window);
  let nativeMatchMedia = false;

  // detect match media support
  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  }

  // prepare resize handler
  function resizeHandler() {
    const winWidth = win.width();
    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth;

      // loop through range groups
      $.each(handlers, (index, rangeObject) => {
        // disable current active area if needed
        $.each(rangeObject.data, (property, item) => {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;
            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        });

        // enable areas that match current width
        $.each(rangeObject.data, (property, item) => {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;
            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }
  win.bind('load resize orientationchange', resizeHandler);

  // test range
  function matchRange(r1, r2) {
    let mediaQueryString = '';
    if (r1 > 0) {
      mediaQueryString += `(min-width: ${r1}px)`;
    }
    if (r2 < Infinity) {
      mediaQueryString += `${mediaQueryString ? ' and ' : ''}(max-width: ${r2}px)`;
    }
    return matchQuery(mediaQueryString, r1, r2);
  }

  // media query function
  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } if (window.media) {
      return media.matchMedium(query);
    }
    return prevWinWidth >= r1 && prevWinWidth <= r2;
  }

  // range parser
  function parseRange(rangeStr) {
    const rangeData = rangeStr.split('..');
    const x1 = parseInt(rangeData[0], 10) || -Infinity;
    const x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort((a, b) => a - b);
  }

  // export public functions
  return {
    addRange(ranges) {
      // parse data and add items to collection
      const result = { data: {} };
      $.each(ranges, (property, data) => {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off,
        };
      });
      handlers.push(result);

      // call resizeHandler to recalculate all events
      prevWinWidth = null;
      resizeHandler();
    },
  };
}(jQuery));
